import { Box } from '@mui/material';
import { STATUS_LABEL, STATUS_TONE } from '../utils/constants';

/** The task's stage as a small pill: Open, In progress, On hold, Review pending, Approved, Completed. */
export default function StatusTag({ status }) {
  const tone = STATUS_TONE[status] || STATUS_TONE[1];
  return (
    <Box component="span" sx={{ display: 'inline-block', whiteSpace: 'nowrap', borderRadius: 1, px: 0.75, py: 0.125, fontSize: 11, fontWeight: 700, bgcolor: tone.bg, color: tone.text }}>
      {STATUS_LABEL[status] || STATUS_LABEL[1]}
    </Box>
  );
}
